/* ========================================
   Proadsy YMMT Vehicle Finder
   Loads real product data, 3 cascading selects,
   shows matching products inline.
   ======================================== */
(function() {
  'use strict';

  function injectLiveMobileFallback() {
    if (document.getElementById('proadsy-live-mobile-fallback')) return;
    var css = [
      '/* Proadsy live mobile fallback 2026-05-03 */',
      '@media (max-width:1080px){',
      'html body [id*="__proadsy_hero"] .hero__grid{grid-template-columns:1fr!important;gap:32px!important;}',
      'html body [id*="__proadsy_hero"] .hero__left,html body [id*="__proadsy_hero"] .hero__tool{max-width:620px!important;width:100%!important;}',
      '}',
      '@media (max-width:600px){',
      'html body [id*="__proadsy_hero"] .hero__container{padding:64px 16px 110px!important;}',
      'html body [id*="__proadsy_hero"] .hero__tool-fields{grid-template-columns:1fr!important;}',
      'html body [id*="__proadsy_hero"] .hero__title{font-size:clamp(38px,13vw,52px)!important;line-height:.96!important;}',
      'html body [id*="__proadsy_hero"] .hero__btn{width:100%!important;justify-content:center!important;}',
      '}'
    ].join('');
    var style = document.createElement('style');
    style.id = 'proadsy-live-mobile-fallback';
    style.textContent = css;
    document.head.appendChild(style);
  }

  injectLiveMobileFallback();

  var DATA_URL = null; // Set by Liquid in hero section
  var vehicleData = null;

  var yearSelect = document.getElementById('yearSelect');
  var makeSelect = document.getElementById('makeSelect');
  var modelSelect = document.getElementById('modelSelect');
  var findVehicleBtn = document.getElementById('findVehicleBtn');
  var finderMessage = document.getElementById('finderMessage');
  var resultsDiv = document.getElementById('ymmtResults');

  if (!yearSelect) return;

  // Find the data URL from script tag or a data attribute
  var scriptEl = document.querySelector('[data-vehicle-json]');
  if (scriptEl) {
    DATA_URL = scriptEl.getAttribute('data-vehicle-json');
  }

  function setOptions(el, values, placeholder) {
    el.innerHTML = '';
    var first = document.createElement('option');
    first.value = '';
    first.textContent = placeholder;
    el.appendChild(first);
    values.forEach(function(v) {
      var opt = document.createElement('option');
      opt.value = v;
      opt.textContent = v;
      el.appendChild(opt);
    });
  }

  var STORAGE_KEY = 'proadsy_ymmt';

  function saveSelection() {
    var year = yearSelect.value;
    var make = makeSelect.value;
    var model = modelSelect.value;
    if (year && make && model) {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify({ year: year, make: make, model: model }));
      } catch(e) {}
    }
  }

  function getSavedSelection() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (raw) return JSON.parse(raw);
    } catch(e) {}
    return null;
  }

  function restoreSelection() {
    var saved = getSavedSelection();
    if (!saved || !vehicleData || !vehicleData.tree) return;

    /* Validate saved data still exists in current vehicle data */
    if (!vehicleData.tree[saved.year]) return;
    if (!vehicleData.tree[saved.year][saved.make]) return;
    if (!vehicleData.tree[saved.year][saved.make][saved.model]) return;

    /* Restore selects */
    yearSelect.value = saved.year;
    updateMakes();
    makeSelect.value = saved.make;
    updateModels();
    modelSelect.value = saved.model;
    showMatchingProducts();
  }

  function loadData() {
    if (!DATA_URL) {
      console.warn('YMMT: No data URL found');
      return;
    }
    fetch(DATA_URL)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        vehicleData = data;
        initYears();
        restoreSelection();
      })
      .catch(function(err) {
        console.error('YMMT: Failed to load vehicle data', err);
      });
  }

  function slugifyVehiclePart(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/\bmercedes-benz\b/g, 'mercedes')
      .replace(/\bchevrolet\b/g, 'chevrolet')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function modelCollectionHandle(make, model) {
    var makeSlug = slugifyVehiclePart(make);
    var modelSlug = slugifyVehiclePart(model);
    if (!makeSlug || !modelSlug) return '';
    return makeSlug + '-' + modelSlug + '-fits';
  }

  /* 主推优先级: 前挡 windshield sunshade → umbrella → side window → cover → pet */
  function productPriority(product) {
    var handle = String(product && product[0] || '').toLowerCase();
    if (handle.indexOf('side-window') !== -1) return 2;
    if (handle.indexOf('umbrella') !== -1) return 1;
    if (handle.indexOf('sunshade') !== -1) return 0;
    if (handle.indexOf('pet') !== -1) return 4;
    if (handle.indexOf('cover') !== -1) return 3;
    return 5;
  }

  function sortedProductIndices(indices, products) {
    return (indices || []).slice().sort(function(a, b) {
      var diff = productPriority(products[a]) - productPriority(products[b]);
      if (diff !== 0) return diff;
      /* 同优先级时有图的排前面，避免主卡裂图/空图 */
      var imgA = products[a] && products[a][2] ? 1 : 0;
      var imgB = products[b] && products[b][2] ? 1 : 0;
      return imgB - imgA;
    });
  }

  function productImageUrl(img, cdn) {
    if (!img) return '';
    var url = cdn + img;
    if (url.indexOf('cdn.shopify.com') !== -1) {
      url += (url.indexOf('?') === -1 ? '?' : '&') + 'width=480';
    }
    return url;
  }

  /* HEAD 验证 collection 存在 → 跳转；404/网络错误 → 降级到带 year 的搜索 */
  function navigateValidated(collectionUrl, fallbackUrl) {
    if (!collectionUrl) {
      window.location.href = fallbackUrl;
      return;
    }
    var done = false;
    function go(url) {
      if (done) return;
      done = true;
      window.location.href = url;
    }
    var timer = setTimeout(function() { go(collectionUrl); }, 2500);
    fetch(collectionUrl, { method: 'HEAD' })
      .then(function(r) {
        clearTimeout(timer);
        go(r.ok ? collectionUrl : fallbackUrl);
      })
      .catch(function() {
        clearTimeout(timer);
        go(fallbackUrl);
      });
  }

  function initYears() {
    if (!vehicleData || !vehicleData.tree) return;
    var years = Object.keys(vehicleData.tree).sort(function(a, b) { return Number(b) - Number(a); });
    setOptions(yearSelect, years, 'Year');
    setOptions(makeSelect, [], 'Make');
    setOptions(modelSelect, [], 'Model');
    hideResults();
  }

  function updateMakes() {
    var year = yearSelect.value;
    if (!vehicleData || !vehicleData.tree[year]) {
      setOptions(makeSelect, [], 'Make');
      setOptions(modelSelect, [], 'Model');
      hideResults();
      return;
    }
    var makes = Object.keys(vehicleData.tree[year]).sort();
    setOptions(makeSelect, makes, 'Make');
    setOptions(modelSelect, [], 'Model');
    hideResults();
  }

  function updateModels() {
    var year = yearSelect.value;
    var make = makeSelect.value;
    if (!vehicleData || !vehicleData.tree[year] || !vehicleData.tree[year][make]) {
      setOptions(modelSelect, [], 'Model');
      hideResults();
      return;
    }
    var models = Object.keys(vehicleData.tree[year][make]).sort();
    setOptions(modelSelect, models, 'Model');
    hideResults();
  }

  /* 车型选择后展示精简的双卡片结果 (sunshade + car cover) */
  function showMatchingProducts() {
    var year = yearSelect.value;
    var make = makeSelect.value;
    var model = modelSelect.value;

    if (!year || !make || !model || !vehicleData) {
      hideResults();
      return;
    }

    var entry = vehicleData.tree[year] && vehicleData.tree[year][make] && vehicleData.tree[year][make][model];
    if (!entry) {
      hideResults();
      return;
    }

    var cdn = vehicleData.cdn || '';
    var products = vehicleData.products || [];

    var types = [
      { key: 'sunshade', label: 'Sunshade', icon: '&#9728;&#65039;' },
      { key: 'car_cover', label: 'Car Cover', icon: '&#128737;&#65039;' }
    ];

    /* 每种产品类型只取第一个作为主卡片，其余计入 extra 数量 */
    var primaryCards = [];
    var totalCount = 0;

    types.forEach(function(t) {
      var indices = sortedProductIndices(entry[t.key], products);
      if (!indices || indices.length === 0) return;
      totalCount += indices.length;
      var p = products[indices[0]];
      if (!p) return;
      primaryCards.push({
        handle: p[0],
        price: p[1],
        imgUrl: productImageUrl(p[2], cdn),
        label: t.label,
        icon: t.icon
      });
    });

    if (primaryCards.length === 0) {
      hideResults();
      return;
    }

    var vehicleName = year + ' ' + make + ' ' + model;
    /* 2026-08-06 hit state: green check draw + result cards spring in (CSS in proadsy-hero.liquid) */
    var html = '<div class="ymmt-results-title">' +
      '<span class="ymmt-check" aria-hidden="true"><svg viewBox="0 0 20 20" fill="none"><circle cx="10" cy="10" r="8.5"/><path d="M5.8 10.3l2.7 2.7 5-5.8"/></svg></span>' +
      '<span>Available for ' + vehicleName +
      ' <span class="tag">EXACT FIT</span></span></div>';

    html += '<div class="ymmt-primary-cards">';
    primaryCards.forEach(function(card) {
      html += '<a href="/products/' + card.handle + '" class="ymmt-card">';
      html += '<div class="ymmt-card-img">';
      if (card.imgUrl) {
        html += '<img src="' + card.imgUrl + '" alt="' + vehicleName + ' ' + card.label + '" loading="lazy">';
      }
      html += '</div>';
      html += '<div class="ymmt-card-body">';
      html += '<div class="ymmt-card-type">' + card.icon + ' ' + card.label + '</div>';
      html += '<div class="ymmt-card-name">' + vehicleName + ' ' + card.label + '</div>';
      html += '<div class="ymmt-card-price">$' + card.price + '</div>';
      html += '<span class="ymmt-card-cta">Shop Now &rarr;</span>';
      html += '<span class="ymmt-card-trust">\u2713 Fit Guaranteed \u00b7 Free Returns</span>';
      html += '</div>';
      html += '</a>';
    });
    html += '</div>';

    /* 超过主卡片展示数量时显示 "See all" 链接 (点击时 HEAD 验证 collection，404 降级搜索) */
    if (totalCount > primaryCards.length) {
      var collectionHandle = entry.collectionHandle || modelCollectionHandle(make, model);
      var searchUrl = '/search?q=' + encodeURIComponent(year + ' ' + make + ' ' + model) + '&type=product';
      var allUrl = collectionHandle ? '/collections/' + collectionHandle : searchUrl;
      html += '<a href="' + allUrl + '" class="ymmt-see-all" data-ymmt-validated-link data-fallback-url="' + searchUrl + '">' +
        'See all ' + totalCount + ' products for your ' + vehicleName + ' &rarr;</a>';
    }

    resultsDiv.innerHTML = html;
    resultsDiv.classList.add('active');
    if (finderMessage) finderMessage.textContent = '';
  }

  function hideResults() {
    if (resultsDiv) {
      resultsDiv.classList.remove('active');
      resultsDiv.innerHTML = '';
    }
  }

  function handleFindVehicle() {
    var year = yearSelect.value;
    var make = makeSelect.value;
    var model = modelSelect.value;

    if (!year || !make || !model) {
      if (finderMessage) finderMessage.textContent = 'Please select year, make, and model.';
      return;
    }

    var searchQuery = year + ' ' + make + ' ' + model;
    localStorage.setItem('proadsy_vehicle', searchQuery);
    var fallbackUrl = '/search?q=' + encodeURIComponent(searchQuery) + '&type=product';
    var entry = vehicleData && vehicleData.tree && vehicleData.tree[year] && vehicleData.tree[year][make] && vehicleData.tree[year][make][model];
    var collectionHandle = entry && entry.collectionHandle ? entry.collectionHandle : modelCollectionHandle(make, model);
    var collectionUrl = collectionHandle ? '/collections/' + collectionHandle : '';
    navigateValidated(collectionUrl, fallbackUrl);
  }

  yearSelect.addEventListener('change', function() {
    updateMakes();
  });
  makeSelect.addEventListener('change', function() {
    updateModels();
  });
  modelSelect.addEventListener('change', function() {
    showMatchingProducts();
    saveSelection();
  });
  if (findVehicleBtn) findVehicleBtn.addEventListener('click', handleFindVehicle);

  /* "See all" 链接拦截：HEAD 验证 collection，404 降级到搜索 */
  if (resultsDiv) {
    resultsDiv.addEventListener('click', function(e) {
      var link = e.target && e.target.closest ? e.target.closest('[data-ymmt-validated-link]') : null;
      if (!link) return;
      e.preventDefault();
      navigateValidated(link.getAttribute('href'), link.getAttribute('data-fallback-url') || link.getAttribute('href'));
    });
  }

  // Load data
  loadData();
})();
